import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { UserManagementContent } from "./UserManagementContent";
import { updateUserAsync } from "@client.pages/Settings/reducer";
import useModal from "@client.hooks/useModal";
import { useDemo } from "@client.hooks/useDemo";

const UpdateButton = ({ user }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { showFormModal } = useModal();
  const { withDemoCheck } = useDemo();

  const onUpdate = () => {
    withDemoCheck(() => showFormModal({
      title: t("components.UserManagementContent.updateUser"),
      component: <UserManagementContent user={user} />,
      footerButtons: [
        {
          icon: "pencil",
          onClick: (managementItem) =>
            dispatch(updateUserAsync(managementItem)),
        },
      ],
    }));
  };

  return (
    <div onClick={onUpdate} className="option">
      {t("components.UserManagementContent.GridManagementButtons.update")}
    </div>
  );
};

UpdateButton.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    role: PropTypes.string,
    teams: PropTypes.array,
  }),
};

export default UpdateButton;
